import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function PausedStatusIcon({ fill = '#505A72', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M3.33333 13V3C3.33333 2.33333 3.66667 2 4.33333 2H5.66667C6.33333 2 6.66667 2.33333 6.66667 3V13C6.66667 13.6667 6.33333 14 5.66667 14H4.33333C3.66667 14 3.33333 13.6667 3.33333 13ZM10.3333 14H11.6667C12.3333 14 12.6667 13.6667 12.6667 13V3C12.6667 2.33333 12.3333 2 11.6667 2H10.3333C9.66667 2 9.33333 2.33333 9.33333 3V13C9.33333 13.6667 9.66667 14 10.3333 14Z"
        fill={fill}
      />
    </svg>
  );
}

export default PausedStatusIcon;
